<template>
  <div align="center">
    <v-dialog ref="dialog" v-model="modal2" persistent max-width="1500px">
      <template v-slot:activator="{ props }">
        <v-btn
          :color="guardado ? 'green' : 'red-darken-4'"
          dark
          prepend-icon="mdi-map-marker-plus"
          size="x-large"
          v-bind="props"
        >
          Complemento:
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="red-darken-4">
          <v-btn icon dark @click="modal2 = false">
            <v-icon>mdi-close </v-icon>
          </v-btn>
          <v-toolbar-title
            ><v-icon left>mdi-map-marker-plus</v-icon> Complemento:
            {{ Complemento }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn class="d-none d-md-block" @click="Guardar()" dark text
              >Guardar</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-row align="center" justify="start">
            <!--Tipo de activo-->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="modelSelected.prefijo3"
                    :items="Prefijo"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Tipo de activo:"
                    :hint="'Elija uno de los activos:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Apto. - Apartamento</span>
              </v-tooltip>
            </v-col>
            <!--Número/Letra-->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.letra4"
                    color="primary"
                    :maxlength="10"
                    :counter="10"
                    clearable
                    dense
                    label="Número/Letra:"
                    :hint="'Ingrese información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>410B</span>
              </v-tooltip>
            </v-col>
            <!--Tipo de activo 2 -->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="modelSelected.prefijo4"
                    :items="Prefijo"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Tipo de Activo:"
                    :hint="'Elija uno de los activos:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Etapa</span>
              </v-tooltip>
            </v-col>
            <!--Número/Letra 2-->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.letra5"
                    color="primary"
                    :maxlength="10"
                    :counter="10"
                    clearable
                    dense
                    label="Número/Letra:"
                    :hint="'Ingrese información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>5A</span>
              </v-tooltip>
            </v-col>
            <!--Tipo de activo 3 -->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="modelSelected.prefijo5"
                    :items="Prefijo"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Tipo de Activo:"
                    :hint="'Elija uno de los tipos de activo:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Par. - Parqueadero</span>
              </v-tooltip>
            </v-col>
            <!-- Número/Letra 3 -->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.letra6"
                    color="primary"
                    :maxlength="10"
                    :counter="10"
                    clearable
                    dense
                    label="Número/Letra:"
                    :hint="'Ingrese solo información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>25LL</span>
              </v-tooltip>
            </v-col>
            <!--Tipo de activo 4 -->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-autocomplete
                    v-model="modelSelected.prefijo6"
                    :items="Prefijo"
                    item-value="Valor"
                    item-title="Descripcion"
                    color="primary"
                    clearable
                    dense
                    label="Tipo de Activo:"
                    :hint="'Elija uno de tipos de activo:'"
                    v-bind="props"
                  >
                  </v-autocomplete>
                </template>
                <span>Torre</span>
              </v-tooltip>
            </v-col>
            <!-- Número/Letra 4 -->
            <v-col cols="12" sm="12" md="3">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.letra7"
                    color="primary"
                    :maxlength="10"
                    :counter="10"
                    clearable
                    dense
                    label="Número/Letra:"
                    :hint="'Ingrese solo información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>5</span>
              </v-tooltip>
            </v-col>
            <!--Adicional Complemento -->
            <v-col cols="12" sm="12" md="12">
              <v-tooltip location="top" color="primary">
                <template v-slot:activator="{ props }">
                  <v-text-field
                    v-model="modelSelected.adicional"
                    color="primary"
                    :maxlength="100"
                    :counter="100"
                    clearable
                    dense
                    label="Complemento:"
                    :hint="'Ingrese información:'"
                    v-bind="props"
                  >
                  </v-text-field>
                </template>
                <span>Bis</span>
              </v-tooltip>
            </v-col>
            <!--Completo -->
            <v-col cols="9" sm="9" md="9">
              <v-text-field
                v-model="modelSelected.complementocompleto"
                label="Complemento Final:"
                :maxlength="300"
                :counter="300"
                readonly
                scrollable
              >
              </v-text-field>
            </v-col>
            <v-col cols="3" sm="3" md="3">
              <v-btn
                class="d-none d-md-block"
                @click="complementocompleta()"
                color="green"
                text
                >Complemento Formateado</v-btn
              >
            </v-col>
          </v-row></v-card-text
        >
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "complemento-modal",
  props: {
    Complemento: {
      type: String,
      default: "",
      Description: "Información de Complemento",
    },
    infoData: {
      type: Object,
      default: null,
      Description: "Información de datos guardados",
    },
  },
  data() {
    return {
      progreso: false,
      modal2: false,
      guardado: false,
      modelSelected: {
        prefijo3: null,
        prefijo4: null,
        prefijo5: null,
        prefijo6: null,
        letra4: null,
        letra5: null,
        letra6: null,
        letra7: null,
        adicional: null,
        complementocompleto: null,
      },
      dataInfo: null,
      Prefijo: [],
    };
  },
  methods: {
    // Numeros
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // Método de Complemento
    complementocompleta() {
      this.modelSelected.complementocompleto = "";
      if (
        this.modelSelected.prefijo3 != "" &&
        this.modelSelected.prefijo3 != undefined &&
        this.modelSelected.prefijo3 != null
      ) {
        this.modelSelected.complementocompleto = this.modelSelected.prefijo3;
      }
      if (
        this.modelSelected.letra4 != "" &&
        this.modelSelected.letra4 != undefined &&
        this.modelSelected.letra4 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra4.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo4 != "" &&
        this.modelSelected.prefijo4 != undefined &&
        this.modelSelected.prefijo4 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo4;
      }
      if (
        this.modelSelected.letra5 != "" &&
        this.modelSelected.letra5 != undefined &&
        this.modelSelected.letra5 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra5.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo5 != "" &&
        this.modelSelected.prefijo5 != undefined &&
        this.modelSelected.prefijo5 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo5;
      }
      if (
        this.modelSelected.letra6 != "" &&
        this.modelSelected.letra6 != undefined &&
        this.modelSelected.letra6 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra6.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.prefijo6 != "" &&
        this.modelSelected.prefijo6 != undefined &&
        this.modelSelected.prefijo6 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.prefijo6;
      }
      if (
        this.modelSelected.letra7 != "" &&
        this.modelSelected.letra7 != undefined &&
        this.modelSelected.letra7 != null
      ) {
        this.modelSelected.complementocompleto +=
          " " + this.modelSelected.letra7.toUpperCase().replace(/ /g, "");
      }
      if (
        this.modelSelected.adicional != "" &&
        this.modelSelected.adicional != undefined &&
        this.modelSelected.adicional != null
      ) {
        this.modelSelected.complementocompleto +=
          " - " + this.modelSelected.adicional.toUpperCase();
      }
      if (
        this.modelSelected.complementocompleto != null &&
        this.modelSelected.complementocompleto != "" &&
        this.modelSelected.complementocompleto != undefined
      ) {
        this.modelSelected.complementocompleto =
          this.modelSelected.complementocompleto.trim().substring(0, 200);
      }
    },
    // Método Guardar
    Guardar() {
      if (
        this.modelSelected.complementocompleto != null &&
        this.modelSelected.complementocompleto != ""
      ) {
        this.$emit(
          "update:Complemento",
          this.modelSelected.complementocompleto
        );
        this.modal2 = false;
        this.guardado = true;
      } else {
        this.guardado = false;
        this.$swal({
          icon: "warning",
          title: "Campos Incompletos.",
          html: " El campo de complemento no contiene ningún regsitro, por favor revisar.",
        });
      }
    },
  },
  mounted() {
    var TablaSeleccion = this.$store.getters.MTablaSeleccion;
    this.Prefijo = TablaSeleccion.filter(
      (item) => item.Valor != null && item.TablaId == 34
    );
    console.log(this.infoData)
    if (this.infoData) {
      this.modelSelected.complementocompleto = this.infoData.ComplementoDireccion;
    }
  },
};
</script>
